import { inject } from '@angular/core';
import { ResolveFn, ActivatedRouteSnapshot } from '@angular/router';
import { ModuleService } from '@services/core/module.service';
import { map } from 'rxjs/operators';

export interface ModuleRouteData {
  module: any;
  routes: string[];
  segment: string;
}

function routeName(module: any): string {
  return pickRoute(module);
}

function pickRoute(module: any): string {
  return module?.routeName || module?.acronym || '';
}

function normalize(segment: string): string {
  return String(segment || '').trim().toLowerCase();
}

function findByRoute(modules: any[], segment: string) {
  return modules.find((item) => isMatch(item, segment)) || null;
}

function isMatch(module: any, segment: string): boolean {
  return normalize(routeName(module)) === normalize(segment);
}

function buildData(list: any[], segment: string): ModuleRouteData {
  return {
    module: findByRoute(list, segment),
    routes: list.map(routeName),
    segment,
  };
}

export function moduleRouteResolver(): ResolveFn<ModuleRouteData> {
  return (route: ActivatedRouteSnapshot) => resolveRoute(route);
}

function resolveRoute(route: ActivatedRouteSnapshot) {
  const moduleService = inject(ModuleService);
  const segment = readSegment(route);
  return fetchRoute(moduleService, segment);
}

function readSegment(route: ActivatedRouteSnapshot): string {
  return route.paramMap.get('moduleRoute') || '';
}

function fetchRoute(moduleService: ModuleService, segment: string) {
  return moduleService.getActiveModules().pipe(
    map((modules: any[]) => buildData(modules || [], segment))
  );
}
